import styled from "styled-components";

export const Container = styled.div`
  .header {
    padding: 16px;
    border-bottom: 1px solid #96989a;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }

    button {
      border: none;
      background-color: transparent;
      height: 22px;
      cursor: pointer;
    }
  }
`;

export const Body = styled.div`
  padding: 16px 32px;
  text-align: center;

  > h2 {
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;

  button {
    cursor: pointer;
    background-color: var(--color-primary);
    color: #fff;
    font-size: 14px;
    padding: 8px 16px;
    border-radius: 5px;
    border: none;

    &:hover {
      background-color: var(--color-primary-dark);
      color: #fff;
    }

    :nth-child(1) {
      background-color: transparent;
      border: 1px solid var(--color-primary);
      color: var(--color-primary);

      &:hover {
        background-color: var(--color-primary-dark);
        color: #fff;
      }
    }
  }
`;
